import BaseViewController from "./base-view-controller";

class SearchTreatmentViewController extends BaseViewController {
  handleSelectChange({ term }) {
    const termField = this.screen.fields.find(field => field.name === "term");
    if (typeof term === "object")
      if (!termField.options.find(option => option.label === term.name)) {
        termField.options.push({
          label: term.name,
          value: term.name
        });
      }
    super.handleSelectChange({
      term: typeof term === "object" ? term.name : term
    });
  }

  preprocessScreenData() {
    this.screen.title = `${
      this.appData.treatmentToEditData.name
        ? this.appData.settings.translations.edit
        : this.appData.settings.translations.add_new
    } treatment`;

    if (this.appData.treatmentToEditData.name) {
      this.appData.values.term = !this.appData.values?.term
        ? this.appData.treatmentToEditData.name
        : this.appData.values.term;
      const previousTreatmentData = {};
      Object.keys(this.appData.dermTreatmentData).forEach(key => {
        previousTreatmentData[key] =
          this.appData.dermTreatmentData[key][
            this.appData.treatmentToEditData.index
          ];
      });

      this.appData.values = {
        ...this.appData.values,
        ...previousTreatmentData
      };
    }
    super.preprocessScreenData();
  }
}

export default SearchTreatmentViewController;
